export default __webpack_public_path__ + "static/media/accesorials.e4e56727.svg";